import React from 'react';

const Footer = () => {
  return (
    <footer class="mt-auto">
      <div class="text-center p-3 text-light" style={{ "background-color": "#7952b3" }}>
        © 2021 <a class="text-light" href="http://cs.scu.edu.cn/e_jsjxy/">College of Computer Science</a>
          , <a class="text-light" href="http://en.scu.edu.cn/">Sichuan University</a>
      </div>
    </footer>
  );
}

export default Footer;
